import script from "./CustomRadioGroup.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomRadioGroup.vue?vue&type=script&setup=true&lang=js"

import "./CustomRadioGroup.vue?vue&type=style&index=0&id=f303895e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f303895e"]])

export default __exports__